import type { HTMLAttributes, Ref } from "react";

import { cn } from "../../utils";
import styles from "./Loading.module.scss";

export type LoadingSize = "xs" | "sm" | "md" | "lg" | "xl";
export type LoadingType =
  | "spinner"
  | "dots"
  | "ring"
  | "ball"
  | "bars"
  | "infinity";

export interface LoadingProps extends HTMLAttributes<HTMLSpanElement> {
  ref?: Ref<HTMLSpanElement>;
  size?: LoadingSize;
  type?: LoadingType;
}

export const Loading = ({
  size = "md",
  type = "spinner",
  className,
  ref,
  ...props
}: LoadingProps) => {
  return (
    <span
      ref={ref}
      className={cn(
        styles[type],
        "ui:pointer-events-none ui:inline-block ui:bg-current ui:mask-size-[100%] ui:mask-center ui:mask-no-repeat ui:align-middle",
        {
          "ui:size-4": size === "xs",
          "ui:size-5": size === "sm",
          "ui:size-6": size === "md",
          "ui:size-7": size === "lg",
          "ui:size-8": size === "xl",
        },
        className,
      )}
      {...props}
    />
  );
};
